import { SURVEY_CATEGORY, SURVEY_PROVIDER } from '../types/global.types'

type TSseUpToRewardLabel = {
  surveyType: SURVEY_CATEGORY
  surveyProvider: SURVEY_PROVIDER
}

export default function useUpToRewardLabel({
  surveyType,
  surveyProvider,
}: Readonly<TSseUpToRewardLabel>) {
  const surveysWithUpToLabel = [SURVEY_PROVIDER.GMOR]

  const isUpToRewardLabel =
    surveyType === SURVEY_CATEGORY.C && surveysWithUpToLabel.includes(surveyProvider)

  return isUpToRewardLabel
}
